import {
    createBrowserRouter,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import Workflow from "./pages/Workflow";
import BaseLayout from "./layout/BaseLayout";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import Private from "./layout/Private";
import DetailsPage from "./pages/DetailsPage";
import Process2DetailsPage from "./pages/Process2DetailsPage";
import Tools from "./pages/Tools";
import Contact from "./pages/Contact";

// V2 Routes
import WorkflowV2 from "./pages/v2/workflow";
import BaseLayoutV2 from "./layout/BaseLayoutV2";
import WorkflowDetails from "./pages/v2/workflow-details";
import TaskView from "./pages/v2/task-view";

const router = createBrowserRouter([
    {
        path: "/",
        element: (
            <BaseLayout>
                <HomePage />
            </BaseLayout>
        )
    },
    {
        path: "workflow",
        element: (
            <BaseLayout>
                <Private>
                    <Workflow />
                </Private>
            </BaseLayout>
        )
    },
    {
        path: "workflow/:processId",
        element: (
            <BaseLayout>
                <Private>
                    <DetailsPage />
                </Private>
            </BaseLayout>
        )
    },
    {
        path: "workflow-process2/:processId",
        element: (
            <BaseLayout>
                <Private>
                    <Process2DetailsPage />
                </Private>
            </BaseLayout>
        )
    },
    {
        path: "contact",
        element: (
            <BaseLayout>
                <Contact />,
            </BaseLayout>
        )
    },
    {
        path: "tools",
        element: (
            <BaseLayout>
                <Private>
                    <Tools />,
                </Private>
            </BaseLayout>
        )
    },
    {
        path: "sign_in",
        element: <SignInPage />,
    },
    {
        path: "sign_up",
        element: <SignUpPage />,
    },
    {
        path: "auth",
        element: <Private />,
    },

    // V2 Routes
    {
        path: "v2/workflow",
        element: (
            <BaseLayoutV2>
                <Private>
                    <WorkflowV2 />
                </Private>
            </BaseLayoutV2>
        )
    },
    {
        path: "v2/workflow/:workflow_id",
        element: (
            <BaseLayoutV2>
                <Private>
                    <WorkflowDetails />
                </Private>
            </BaseLayoutV2>
        )
    },
    {
        path: "v2/task/:task_id",
        element: (
            <BaseLayoutV2>
                <Private>
                    <TaskView />
                </Private>
            </BaseLayoutV2>
        )
    },
]);

export default router;